import { render, staticRenderFns } from "./LegalDutyDependentChildFS.vue?vue&type=template&id=a13dbbbc&scoped=true"
import script from "./LegalDutyDependentChildFS.vue?vue&type=script&lang=ts"
export * from "./LegalDutyDependentChildFS.vue?vue&type=script&lang=ts"
import style0 from "./LegalDutyDependentChildFS.vue?vue&type=style&index=0&id=a13dbbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13dbbbc",
  null
  
)

export default component.exports